import client from './client';

export const listWildfires = (params) =>
  client.get('/wildfires', { params }).then((r) => r.data);

// Lightweight, un-paginated list scoped to a tenant — used by the wildfires
// index list/map view. Returns only the fields needed to render a row or
// marker (no weather / firefighter / user joins), so the whole FPA history
// fits in one response.
export const listWildfiresForMap = (params) =>
  client.get('/wildfires/map', { params }).then((r) => r.data);

// Distinct fire-season tags an FPA has fires for, plus the season tag for
// today (per the global app-settings config). Drives the season picker.
export const listWildfireSeasons = (params) =>
  client.get('/wildfires/seasons', { params }).then((r) => r.data);

export const getWildfire = (id) =>
  client.get(`/wildfires/${id}`).then((r) => r.data);

export const createWildfire = (data) =>
  client.post('/wildfires', data).then((r) => r.data);

export const updateWildfire = (id, data) =>
  client.put(`/wildfires/${id}`, data).then((r) => r.data);

export const deleteWildfire = (id) =>
  client.delete(`/wildfires/${id}`).then((r) => r.data);

// Approval queue — DRAFT fires awaiting submission (approver-only).
export const listPendingWildfires = (params) =>
  client.get('/wildfires/pending', { params }).then((r) => r.data);

// Promote a DRAFT report to SUBMITTED (approver-only).
export const submitWildfire = (id) =>
  client.post(`/wildfires/${id}/submit`).then((r) => r.data);

export const getStatsSummary = (params) =>
  client.get('/wildfires/stats/summary', { params }).then((r) => r.data);

export const getMonthlyProfile = (params) =>
  client.get('/wildfires/stats/monthly-profile', { params }).then((r) => r.data);

export const getFdiDistribution = (params) =>
  client.get('/wildfires/stats/fdi-distribution', { params }).then((r) => r.data);

export const getWeatherProfile = (params) =>
  client.get('/wildfires/stats/weather-profile', { params }).then((r) => r.data);

export const getCauseBySeason = (params) =>
  client.get('/wildfires/stats/cause-by-season', { params }).then((r) => r.data);

// Attendance leaderboard per firefighter/volunteer (incidents, area, injury fires).
export const getFirefighterStats = (params) =>
  client.get('/wildfires/stats/by-firefighter', { params }).then((r) => r.data);

// Who assisted THIS FPA, per assisting FPA or organisation. The receiving side
// of mutual aid; the giving side is listAidProvided in api/aid.js, which reads
// receipt rows instead because an FPA cannot query another FPA's fires.
// Incidents count distinct fires, so a brigade sending two stations to one
// fire reads as one callout with two lots of people.
export const getMutualAidStats = (params) =>
  client.get('/wildfires/stats/mutual-aid', { params }).then((r) => r.data);
